export default __webpack_public_path__ + "static/media/508.b3563f1b.png";